import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["schoolsModal", "content", "juriesModal", "juriesContent"];

  show(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.url;
    const school_count = event.currentTarget.dataset.school_count;
    if (school_count == 0) {
      alert("Aucune école disponible pour ce centre.");
      return;
    }
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        this.contentTarget.innerHTML = html;
        this.schoolsModalTarget.classList.add("is-active");
      });
  }

  showJuries(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.url;
    const juries_count = event.currentTarget.dataset.juries_count;
    if (juries_count == 0) {
      alert("Aucun jury de soutenance pour ce centre.");
      return;
    }
    if (!this.hasJuriesModalTarget) return;
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        this.juriesContentTarget.innerHTML = html;
        this.juriesModalTarget.classList.add("is-active");
      });
  }

  destroy() {
    this.schoolsModalTarget.classList.remove("is-active");
    this.contentTarget.innerHTML = "";
  }

  destroyJuries() {
    if (this.hasJuriesModalTarget) {
      this.juriesModalTarget.classList.remove("is-active");
      this.juriesContentTarget.innerHTML = "";
    }
  }
}
